<template>
  <div v-if="isLoading && !isError" class="loading-spinner text-center">
    <div class="spinner-border spinner-size" role="status">
      <span class="visually-hidden fs-1">{{ $t('key_loading') }}</span>
    </div>
  </div>
  <div v-if="isError" class="my-10 text-center">
    <i class="fa fa-times-circle-o text-danger" aria-hidden="true" style="font-size: 3.5rem"></i>
    <h4 class="mt-2">{{ $t('key_file_not_loaded') }}</h4>
  </div>
  <div v-if="!isLoading && !isError" class="gallery row">
    <slot
      v-for="(img, index) in images"
      :key="`${index}-${img['name']}`">
      <ImageItem
        :image='img'
        :error-remove='errorRemove'
        :error-download='errorDownload'
        :success-download='successDownload'
        :confirm-delete='confirmDelete'
        @remove="removeItem"
        @download="downloadItem"
        @request-remove="updateResource"
      />
    </slot>
    
    <FileSelector
      class="gallery-new-item col-lg-1"
      accept-extensions=".jpg,.svg,.png"
      :multiple="false"
      :max-file-size="5 * 1024 * 1024"
      :errors="errorUpload"
      :success="successUpload"
      @changed="handleFilesChanged"
    />
  </div>
</template>

<script>

  import FileSelector from './FileSelector.vue'
  import ImageItem from './ImageItem'
  import { createAxios } from "@/services/axiosHttp";

  export default {
    name: "ImageList",
    components: {
      FileSelector,
      ImageItem
    },
    props: {
      images: {
        type: Object,
        default: () => {
          return {};
        },
      },
      errors: {
        type: [ Object, String ],
        default: () => {
          return null;
        },
      },
      url: {
        type: String,
        default: '',
      },
      entityId: {
        type: String,
        default: '',
      },
      confirmDelete: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
    },
    emits: ['switch', 'changed', 'remove-item', 'download-item', 'success-upload', 'request-remove', 'error-handler'],
    data() {
      return {
        gallery: [],
        isLoading: true,
        isError: false,
        showDeleteButton: false,
        isErrorRemoving: false,


        errorUpload: null,
        successUpload: null,
        errorRemove: null,
        errorDownload: null,
        successDownload: null,
        resourceDeleteRequested: null,
      }
    },
    computed: {},
    watch: {
      images() {
        if(this.images) {
          this.isLoading = false
        } else {
          this.isLoading = true
        }
      },
      errors() {
        if(this.errors){
          this.isLoading = false
          this.isError = true
        }
      },
      confirmDelete() {
        if(this.confirmDelete && typeof this.confirmDelete == 'boolean') {
          this.removeItem({ ...this.resourceDeleteRequested })
          this.resourceDeleteRequested = null
        }
      },
    },
    mounted() {
      if (this.images) {
        this.isLoading = false
      }
    },
    methods: {
      go() {
        this.$emit('switch', this.itemRef)
      },
      updateResource(img) {
        this.resourceDeleteRequested = { ...img }
        this.$emit('request-remove', img)
      },
      getImageName(value) {
        const name = value.split('/')[2]
        return name
      },
      removeItem(value) {
        const axios = createAxios();
        const fileName = value['name'].split('/')[2]

        const user= JSON.parse(localStorage.getItem("user"));
        const url = `customer/${user.extraData.customerId}/${this.url}/${this.entityId}/resources?filename=${fileName}`
      
        axios.delete(url,)
        .then(() => {
          this.$emit('remove-item', { type: 'img', entity: value });
        }).catch((error) => {
          this.errorRemove = error
        })
      },
      downloadItem(value) {
        const axios = createAxios();
        const fileName = value['name'].split('/')[2]

        const user= JSON.parse(localStorage.getItem("user"));
        const url = `customer/${user.extraData.customerId}/${this.url}/${this.entityId}/resource?filename=${fileName}`
      
        axios.get(url, {
          responseType: 'blob'
        })
        .then((blob) => {
          const link = document.createElement("a");
          link.setAttribute('download', fileName);
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
          this.successDownload = true
          setTimeout(() => {
            this.successDownload = null
          }, 100)
        }).catch((error) => {
          this.errorDownload = error
        })
      },
      handleFilesChanged(value) {
        const axios = createAxios();
        let dataForm = new FormData();
        dataForm.append('file', value);

        let config = {header : {'Content-Type' : 'multipart/form-data'}}
        const user= JSON.parse(localStorage.getItem("user"));
        const url = `customer/${user.extraData.customerId}/${this.url}/${this.entityId}/resources`
      
        axios.post(url, dataForm, config)
        .then((res) => {
          this.successUpload = { ...res }
          this.$emit('success-upload', { type: 'img', entity: this.successUpload });
        }).catch(
          (error) => {
            this.errorUpload = error
            this.$emit('error-handler', error['error'])
          }
        )
      }
    }
  };
  
</script>

<style scoped lang="scss">

  .spinner-size {
    width: 3rem;
    height: 3rem;
  }

  .loading-spinner {
    position: absolute;
    top: 16rem;
    left: 20rem;
  }

  .gallery {
    //display: flex;
    flex: auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: left;
    // margin: 0 0 -0.5rem 1.5rem;
    margin-left: .2rem;
  }
  
</style>